import { forwardRef, type HTMLAttributes, useState } from 'react';

import { VirtualMultiselectRootContext } from '../contexts/root.context';

interface VirtualMultiselectRootProps<V extends string>
  extends HTMLAttributes<HTMLDivElement> {
  value: V[];
  onValueChange: (value: V[]) => void;
}

export const _VirtualMultiselectRoot = forwardRef<
  HTMLDivElement,
  VirtualMultiselectRootProps<string>
>(({ children, value, onValueChange, ...props }, ref) => {
  const [availableItemsSet, setAvailableItemsSet] = useState(new Set<string>());

  return (
    <VirtualMultiselectRootContext.Provider
      value={{
        value,
        onValueChange,
        availableItemsSet,
        setAvailableItemsSet,
      }}
    >
      <div ref={ref} {...props}>
        {children}
      </div>
    </VirtualMultiselectRootContext.Provider>
  );
});

_VirtualMultiselectRoot.displayName = 'VirtualMultiselectRoot';

export const VirtualMultiselectRoot = _VirtualMultiselectRoot as <
  V extends string,
>(
  props: VirtualMultiselectRootProps<V> & { ref?: React.Ref<HTMLDivElement> },
) => React.ReactNode;
